/**
 * PATH: apps/qa/src/pages/ncr-detail/helpers.ts
 * PURPOSE: Status and severity config helpers for NCR detail pages
 */

import {
  AlertTriangle,
  CheckCircle,
  Clock,
  XCircle,
} from 'lucide-react'
import { createElement } from 'react'

export interface NCRAction {
  id?: string
  action_type: string
  action_text?: string
  notes?: string
  created_at?: string
  actor_name?: string
  created_by_name?: string
}

export interface StatusConfig {
  icon: React.ReactNode
  bg: string
  text: string
  label: string
}

export interface SeverityConfig {
  bg: string
  text: string
}

export function getStatusConfig(status: string): StatusConfig {
  switch (status) {
    case 'open':
      return { icon: createElement(AlertTriangle, { className: 'w-5 h-5' }), bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-400', label: 'Open' }
    case 'in_progress':
      return { icon: createElement(Clock, { className: 'w-5 h-5' }), bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-700 dark:text-blue-400', label: 'In Progress' }
    case 'ready_for_review':
      return { icon: createElement(CheckCircle, { className: 'w-5 h-5' }), bg: 'bg-purple-100 dark:bg-purple-900/30', text: 'text-purple-700 dark:text-purple-400', label: 'Ready for Review' }
    case 'closed':
      return { icon: createElement(XCircle, { className: 'w-5 h-5' }), bg: 'bg-muted', text: 'text-muted-foreground', label: 'Closed' }
    default:
      return { icon: createElement(AlertTriangle, { className: 'w-5 h-5' }), bg: 'bg-muted', text: 'text-muted-foreground', label: status }
  }
}

export function getSeverityConfig(sev: string): SeverityConfig {
  switch (sev) {
    case 'critical': return { bg: 'bg-red-100 dark:bg-red-900/30', text: 'text-red-700 dark:text-red-400' }
    case 'high': return { bg: 'bg-orange-100 dark:bg-orange-900/30', text: 'text-orange-700 dark:text-orange-400' }
    case 'medium': return { bg: 'bg-amber-100 dark:bg-amber-900/30', text: 'text-amber-700 dark:text-amber-400' }
    case 'low': return { bg: 'bg-blue-100 dark:bg-blue-900/30', text: 'text-blue-700 dark:text-blue-400' }
    default: return { bg: 'bg-muted', text: 'text-muted-foreground' }
  }
}
